<template>
  <div class="convertPage">
      <div class="convertContainer">
        <div class="topContainer">
          <div class="startConvert" style="background:white;">
            <h3 style="font-size:0.3rem;font-weight:bold;text-align:left;color:rgba(51,51,51,1);padding-top:0.2rem;padding-left:0.2rem;">兑换播豆:</h3>
            <div class="start">
              <span>￥</span>
              <input  type="text" v-model="realmoney" @input='changeValu()'  :readonly='isreadonly'/>
              <span>=</span>
              <input type="text" v-model="beanMoney" style="text-align:right;" readonly>
              <span style="margin-left:0.14rem;font-weight:bold;
                     color:rgba(51,51,51,1);font-size:0.3rem;">播豆</span>
            </div>
            <div class="no"  v-if="isNo">兑换余额不足</div>


          </div>
         
        </div>
        <div class="balance">
           <p>账户余额:<span style="margin-left:0.1rem;">{{balance}}</span></p>
        </div>
        <div class="tips">
          <p>兑换说明:</p>
          <p>1、兑换比例为：1元=10播豆，余额兑换播豆后，不可退还，也不可提现。</p>
          <p>2、兑换好的播豆可以用于支付福袋和购买礼物。</p>
          <p>3、兑换后如有任何问题，本平台拥有最终解释权。</p>
        </div>
        <div class="buyBean">
             <div>
              <img src="../../assets/img/sureConvert.png" alt=""  @click="wechatBuy()">
             </div>
            
        </div>
      </div>
    
  </div>

  
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  name: 'convertPage',
  data:function(){
    return{
      balance:0,
      realmoney:'',
      beanMoney:'',
      isNo:false,
      isreadonly:false,




    }
  },

  methods:{
    changeValu:function(){
      if (this.realmoney==0) {
        this.realmoney='';
      }
    
      if (this.realmoney=='' || this.realmoney==undefined) {
         this.beanMoney=''
         this.isNo=false;
         return;
      }
      if(this.realmoney.toString().charAt(0)=='.'){
        this.realmoney='0.'
        return;
      }
      if (!this.numberCheck(this.realmoney)) {
        var realIndex = 0;
        var regs=/[a-z,A-Z]/g;
        var reg =/[\u4e00-\u9fa5]/g;
        // 去除input框输入的字母特殊符号
        for(var i = 0; i<this.realmoney.length; i++){
          var strn = this.realmoney[i];
          var regEn = /[`~!@#$%^&*()_+<>?:"{},\\/;'[\]]/im,
              regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
          if (/[\u4e00-\u9fa5_a-zA-Z]/g.test(this.realmoney[i]) ||  regEn.test(this.realmoney[i]) || regCn.test(this.realmoney[i]) ){
            realIndex = i;
            this.realmoney=this.realmoney.replace(this.realmoney[realIndex],"");
           
           }else{
                if (Number(this.realmoney)>Number(this.balance)) {
                  this.realmoney=this.balance;
                  this.beanMoney=Number(this.realmoney)*10;
                  this.isNo=true;
                 }else{
              
                  let a=this.realmoney.substring(0,this.realmoney.indexOf('.')+2,1);
                  this.realmoney=parseFloat(a);
                  this.beanMoney=Number(this.realmoney)*10;
                  this.isNo=false;
                }
           }
         }
         let a=String(this.realmoney);
        this.realmoney = a.replace(reg,'');
        return;
        
      }else{

        if (Number(this.realmoney)>Number(this.balance)) {
         
          this.realmoney=this.balance.substring(0,this.balance.indexOf('.')+2,1);
          this.beanMoney=Number(this.realmoney*10);
          this.isNo=true;
        }else{
          this.beanMoney=Number(this.realmoney*10);
          this.isNo=false;
        }
     
      }
    },
   
    numberCheck:function(num){
      var re=/^\d*\.{0,1}\d{0,1}$/;
      return re.exec(num) != null;
    },
    roundFun:function(value,n){
       return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
    },
    wechatBuy:function(){
        if (this.realmoney=='') {
           Toast({
                message: '兑换金额不能为空',
                position: 'center',
                duration: 5000
            });
            return;
        }
        if (this.realmoney==0) {
            Toast({
                message: '兑换金额不能为零',
                position: 'center',
                duration: 5000
            });
            return;
          
        }
        var self = this;
        self.http.post(this.cbct.https()+'/h5/channel/account/beans-transfer-charge', this.qs.stringify({
          amount:Number(this.realmoney*100),
          type:'act',
          })).then((response)=>{
            if(response.c == this.cbct.code.successRes){
              if (response.d.status=='1') {
                 Toast({
                  message: '兑换成功',
                  position: 'center',
                  duration: 5000
                 });
                self.$router.go(-1);
                this.realmoney='';
                this.beanMoney='';
              }

           
            }else if(response.c == this.cbct.code.noLogin){
                Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
                timing.time();
            }else if(response.c ==this.cbct.code.raleNoLogin){
                self.$router.push({path:'./register?returnUrl=convertPage?Truechnnel_id='+this.$route.query.Truechnnel_id });
            }else{
               Toast({
                    message: '服务器开小差，请稍后重试',
                    position: 'center',
                    duration: 5000
                });
            }
            
        }
        ).catch((error)=>{console.log(error);})


    },
  },
  created(){
    //判断是否授权
    if(this.cbct.getCookie('openId') == undefined ||this.cbct.getCookie('openId') == ''){
        this.$router.push({path:'./change?channel_id='+this.$route.query.Truechnnel_id});
    }


    this.timing.time();
    $('title').html(decodeURIComponent(this.cbct.getCookie('channel_name')));
    let self=this;
    // this.withdrawBalance();
    self.balance=self.$route.query.gold;
    self.realmoney=self.$route.query.gold.substring(0,self.$route.query.gold.indexOf('.')+2,1);
    // self.realmoney=self.$route.query.gold;
    let a=self.$route.query.gold.substring(0,self.$route.query.gold.indexOf('.')+2,1);
    self.beanMoney=parseFloat(a)*10;


  },
  mounted(){
   
  },
  components:{

  }
  
}


</script>
<style scoped lang="scss">
   .convertPage{
      width: 100%;
      height: auto;
      overflow: hidden;
      box-sizing: border-box;

      .convertContainer{
        width: 100%;
        box-sizing: border-box;
        .topContainer{

          .startConvert{
            // padding: 0 0.4rem;
            .start{
             display: flex;
             align-items: center;
             font-weight:bold;
             color:rgba(51,51,51,1);
             font-size: 0.415rem;
             padding: 0.33rem 0.4rem;
             border-bottom: solid 1px rgba(222,222,222,1);
             input{
               width: 36%;
               border: none;
               outline: none;
               background: white;
             } 
            }
            .no{
              font-weight:400;
              color:rgba(204,50,50,1);
              font-size:0.24rem;
              text-align: left;
              padding: 0.24rem 0.4rem;

            }

          }

        }
        .balance{
          padding: 0.42rem 0 0 0.32rem;
          font-weight:500;
          color:rgba(51,51,51,1);
          font-size: 0.3rem;
          text-align: left;
        }
      
        .tips{
          font-weight:500;
          color:rgba(153,153,153,1);
          font-size: 0.24rem;
          padding: 0.42rem 0.97rem 0.94rem 0.32rem;
          text-align: left;
          line-height: 0.4rem;
          

        }
        .buyBean{
          width: 100%;
          margin: auto;
          text-align: center;
          img{
            width: 5.86rem;
            display: block;
            margin-left: 0.83rem;
          }
        }



      }
    
     
   }
 
</style>

